import { InjectionToken } from '@angular/core';

/**
 * Host-provided analytics sink (e.g. desktop wires this to Firebase `logEvent`). CADS does not import Firebase or
 * Brightside `FbDirective`; event **names** mirror `FbDirective` / `brightsideWebFb` for built-in back + config CTAs
 * when {@link CadsMainTemplateConfig.analytics} is set.
 */
export interface CadsMainTemplateAnalyticsSink {
  /** Same contract as typical `FirebaseService.logEvent` first two arguments. */
  logEvent(eventName: string, eventParams?: { [key: string]: string }): void;
}

/**
 * Provide with `useFactory` / `FirebaseService` in the host app when using {@link CadsMainTemplateConfig.analytics}.
 */
export const CADS_MAIN_TEMPLATE_ANALYTICS = new InjectionToken<CadsMainTemplateAnalyticsSink>(
  'CADS_MAIN_TEMPLATE_ANALYTICS',
);

/**
 * Shell-level analytics payload (shape aligned with desktop `AnalyticsAttributesV4` fields used by `FbDirective`).
 */
export interface CadsMainTemplateAnalyticsAttributes {
  readonly event_name: string;
  readonly custom?: { readonly [key: string]: string };
}

/**
 * Immutable copy of `FbDirective.cleanEventName`: lowercases, splits on `_`, drops trailing segments
 * `dismissed`, `shown`, `tapped`, or `dismiss`, then joins with spaces.
 */
export function cleanCadsMainTemplateFbEventName(eventName: string): string {
  const eventNameArray = eventName.toLowerCase().split('_');
  for (let i = eventNameArray.length - 1; i >= 0; i--) {
    const seg = eventNameArray[i];
    if (seg === 'dismissed' || seg === 'shown' || seg === 'tapped' || seg === 'dismiss') {
      eventNameArray.splice(i, 1);
    }
  }
  return eventNameArray.join(' ');
}
